import { useAuth } from "@clerk/clerk-react";
import { PrimaryFullScreenSpinner, Spinner } from "@repo/ui";
import { createFileRoute } from "@tanstack/react-router";
import { GraphiQL } from "graphiql";
import { opsHead } from "~/head";
import "graphiql/graphiql.css";
import { Suspense } from "react";
import { config } from "~/config";

export const Route = createFileRoute("/__auth/playground")({
  head: () => opsHead("Playground"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

function View() {
  const auth = useAuth();

  const fetcher = async (graphQLParams: any) => {
    const token = await auth.getToken();
    if (!token) {
      throw new Error("failed to get auth token");
    }
    const response = await fetch(`${config.apiUrl}/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(graphQLParams),
    });
    return response.json();
  };

  if (!auth.isLoaded) {
    return <Spinner />;
  }

  return (
    <div className="h-screen">
      <GraphiQL forcedTheme="light" fetcher={fetcher} />
    </div>
  );
}
